<template>
  <div
    class="interest_form_bonus"
  >
    <div class="container">
      <div class="drag">
        <div class="stepper">
          <van-stepper
            v-model="currentBonusCustomRate"
            :min="0"
            :max="maxBonusCustomRate"
            :step="bonusAccStep"
            input-width="40px"
            :integer="type==='bonus'"
          />
        </div>
        <div class="footer_wrapper">
          <span @click="confirm">{{ settingName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BottomSheets } from "bxs-ui-vue";


export default {
  components: {
    [BottomSheets.name]: BottomSheets,
  },

  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    previousBonusCustomRate: {
      type: [Number, String],
    },
    maxBonusCustomRate: {
      type: Number,
    },
    settingName:{
      type: String,
    },
    type:{
      type:String,
    },
    step:{
      type:Number,
    }
  },

  data() {
    return {
      bonusAccStep:null,
      currentBonusCustomRate: 0,
      isClickConfirm: false,
    };
  },
  
  watch: {
    previousBonusCustomRate: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal !== null) {
          const numVal = Number(newVal);
          if (numVal <= 0.05 && this.type === 'acc') {
            this.currentBonusCustomRate = Number((numVal * 100).toFixed(2));
          } else {
            this.currentBonusCustomRate = numVal;
          }
        }
      }
    }
  },
  created() {
    const numVal = Number(this.previousBonusCustomRate);
    if (this.type === 'acc') {
      this.currentBonusCustomRate = Number((numVal * 100).toFixed(2));
    } else {
      this.currentBonusCustomRate = numVal;
    }
    this.bonusAccStep = this.step;
  },

  methods: {
    // 确定
    confirm() {
      let tempBonusCustomRate = this.currentBonusCustomRate
      if (tempBonusCustomRate !== this.previousBonusCustomRate) {
        if(this.type==='bonus'){
          this.$emit("update", {
            bonusCustomRate: tempBonusCustomRate,
            yearBonusRate: this.percentToFractional(tempBonusCustomRate),
            endBonusRate:  this.percentToFractional(tempBonusCustomRate),
          });
        }else if(this.type==='acc'){
          this.$emit("update", {
            accRate: Number((tempBonusCustomRate/100).toFixed(4)),
          });
        }

        this.isClickConfirm = true;
        return
      }
      this.isClickConfirm = true;
    },
    percentToFractional(percent, digits = 2) {
      if (!percent && percent !== 0) {
        return null
      }
      const rawNum = Number(percent)
      if (Number.isNaN(rawNum)) {
        return null
      }
      return Number((rawNum / 100).toFixed(digits))
    },
  },
};
</script>

<style lang="postcss">
@import "./interest-form-bonus.css";
</style>

